import React, { memo } from 'react'
import { MarketplaceEligibility, MARKETPLACE_TYPE } from './MarketplaceEligibility'

interface IMarketplaceStatusProps {
  reasons?: {
    base: string[]
    marketplace: string[]
    loadBoards: string[]
  }
}

export const MarketplaceStatus = memo<IMarketplaceStatusProps>(({ reasons }) => {
  const baseReasons = reasons?.base ?? []
  const marketplaceReasons = reasons?.marketplace ?? []
  const loadBoardReasons = reasons?.loadBoards ?? []
  return (
    <>
      <div className='row'>
        <div className='fl'>
          <div className='body-medium'>Marketplace Status</div>
        </div>
      </div>
      <div className='mb4' data-test='market-eligibility'>
        <MarketplaceEligibility
          type={MARKETPLACE_TYPE.marketplace}
          baseReasons={baseReasons}
          specificReasons={marketplaceReasons}
        />
        <MarketplaceEligibility
          type={MARKETPLACE_TYPE.loadBoard}
          baseReasons={baseReasons}
          specificReasons={loadBoardReasons}
        />
      </div>
    </>
  )
})
